import React from 'react';
import { Table } from 'semantic-ui-react';
import { NoData } from "../../components/table/no-data";

class QsrCommentaryTableRow extends React.Component {
    state = {
        utility: 'Gas',
        loadingread: true,

        address: "",
        serialnumber: "",
        ref: "",
        propertyname: "",
        lastreading: "",
        lastreadtype: "",
        datelastread: "",
        description: "",

        metersCount: {},
        completenessData: []

    }


    getMeterRead = (customerId, meterSiteKey) => {

    }

    render() {

        return (
            <Table.Row>
                <Table.Cell>{this.props.data.commentKey || <NoData />}</Table.Cell>
                <Table.Cell>{this.props.data.reportArea || <NoData />}</Table.Cell>
                <Table.Cell>{this.props.data.specialEvent || <NoData />}</Table.Cell>
                <Table.Cell>{this.props.data.fldDate.split(" ")[0] || <NoData />}</Table.Cell>
                <Table.Cell style={{ wordBreak: "break-all" }}>{this.props.data.comment || <NoData />}</Table.Cell>
                <Table.Cell style={{ wordBreak: "break-all" }}>{this.props.data.action || <NoData />}</Table.Cell>
            </Table.Row>
        );
    }
}

export default QsrCommentaryTableRow;